// package imports
import React from 'react';
import { IconType } from 'react-icons';

// CSS imports
import './PrimaryButton.css';

type Props = {
  className?: string;
  label?: string;
  ReactIcon?: IconType;
  imgIcon?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const PrimaryButton: React.FC<Props> = ({
  className,
  label,
  ReactIcon,
  imgIcon,
  disabled,
  onClick,
}: Props) => {
  return (
    <button
      className={`PrimaryButton ${className ? className : ''}`}
      onClick={onClick}
      disabled={disabled ? disabled : undefined}
    >
      {ReactIcon ? (
        <ReactIcon className={label ? 'btn-icon' : 'only-btn-icon'} />
      ) : imgIcon ? (
        <img
          src={imgIcon}
          alt={label}
          className={label ? 'btn-icon' : 'only-btn-icon'}
        />
      ) : null}
      <b>{label ? label : null}</b>
    </button>
  );
};

export default PrimaryButton;
